import imgBv128 from "../assets/projects/bv_128.avif";
import imgBvDor from "../assets/projects/bv_dor.avif";
import imgBv99 from "../assets/projects/bv_99.avif";
import imgBv74 from "../assets/projects/bv_74.avif";
import imgBv26 from "../assets/projects/bv_26.avif";
import imgBv111 from "../assets/projects/bv_111.avif";
import imgBv164 from "../assets/projects/bv_164.avif";
import imgBv159 from "../assets/projects/bv_159.avif";
import imgBv154 from "../assets/projects/bv_154.avif";
import imgBv149 from "../assets/projects/bv_149.avif";
import imgBv146 from "../assets/projects/bv_146.avif";
import imgBv144 from "../assets/projects/bv_144.avif";
import imgBv155 from "../assets/projects/bv_155.avif";

export const projectsDataEn = {
  bv128: {
    title: "BV 128 General renovation Riedbahn",
    subtitle: "Comprehensive LST cable routing and infrastructure renewal along the Riedbahn corridor.",
    tags: ["lst"],
    tagLabel: "LST Cable Routing",
    image: imgBv128,
    summary: [
      "84 km trunk cable - laid on schedule",
      "15 km branch cable - precision execution",
      "20 km cable ducts - opening, cleaning, and professional closure",
      "43 km cable rerouting - completed on schedule",
      "4 km provisional cable duct - new construction",
      "7 km cable pulling in tunnel - special pulling technique",
      "1 km rail-foot cable installation in E60 rail with rail clamps",
      "170 drum transports",
      "Further cable civil works",
      "Cable cabinet installation with PT2 plan",
      "Joint planning & Cable entry installation",
    ],
    logistics: [
      "2x drum trailers, each with 4.5 t capacity",
      "1x truck with 120 t capacity",
      "2x wheel loaders for drum sorting",
      "1x two-way excavator",
      "2x auxiliary rope winches HSW-B 750",
      "RUNPOTEC fiberglass rods: 400 m, 200 m, 120 m",
      "300 cable rollers",
      "SKL 53 rail service vehicle with rail trailer",
      "Cable pulling grips with loop: 20 mm, 40 mm, 60 mm, 80 mm, 120 mm, 160 mm",
    ],
  },
  bvdornheim: {
    title: "BV Dornheim - Dornberg-Nord",
    subtitle: "12.5 km LST cable routing with duct cleaning, sealing, and underground installation.",
    tags: ["lst"],
    tagLabel: "LST Cable Routing",
    image: imgBvDor,
    summary: [
      "12.5 km trunk cable - laid on schedule",
      "12 km cable ducts - opening, cleaning, and professional closure",
      "27 drum transports",
      "Further cable civil works",
      "Application of 2,500 cable identification bands",
      "Cable entry installation",
    ],
    logistics: [
      "1 drum trailer with 4.5 t capacity",
      "1 two-way excavator",
      "2 auxiliary rope winches HSW-B 750",
      "300 cable rollers",
      "SKL 53 rail service vehicle with rail trailer",
    ],
  },
  bv99: {
    title: "BV 99 ESTW Lieblos 2024",
    subtitle: "15.8 km LST cable installation with fiber optics, tunnel works, and precision logistics.",
    tags: ["lst"],
    tagLabel: "LST Cable Installation",
    image: imgBv99,
    summary: [
      "15.8 km LST cable - efficient and on-schedule installation",
      "25 km fiber optic cable - careful execution of installation",
      "11 km branch cable - precise execution",
      "29.5 km cable ducts - vegetation works, opening, cleaning, and professional closure",
      "1 km cable pulling in tunnel - special pulling technique",
      "18 extra-length fiber cabinets - special feed-in technique",
      "27 drum transports & Further cable civil works",
      "Application of 10,000 cable identification bands",
    ],
    logistics: [
      "1 drum trailer with 4.5 t capacity",
      "1 two-way excavator",
      "2 auxiliary rope winches HSW-B 750",
      "300 cable rollers",
      "Cable pulling grips with loop: 20 mm, 40 mm, 60 mm, 80 mm, 120 mm, 160 mm",
    ],
  },
  bv74: {
    title: "BV 74 ESTW S8 North & ESTW S1 North 2024",
    subtitle: "Corridor upgrade with tracks, drainage, platforms, and reliable LST/50 Hz cable routing.",
    tags: ["lst"],
    tagLabel: "LST & 50 Hz Cable",
    image: imgBv74,
    summary: [
      "81 km trunk cable - laid on schedule",
      "11 km branch cable - precise execution",
      "8.5 km cable ducts - opening, cleaning, and professional closure",
      "7 km cable pulling in tunnel - special pulling technique",
      "1 km rail-foot cable installation in E60 rail with rail clamps",
      "101 drum transports",
      "Further cable civil works & Joint planning",
    ],
    logistics: [
      "2 drum trailers, each with 4.5 t capacity",
      "1 two-way excavator",
      "1 auxiliary rope winch HSW-B 750",
      "300 cable rollers",
      "SKL 53 rail service vehicle with rail trailer",
      "Cable pulling grips with loop: 20 mm, 40 mm, 60 mm, 80 mm, 120 mm, 160 mm",
    ],
  },
  bv26: {
    title: "BV 26 Tönning 2023",
    subtitle: "Cable Laying package for route 1204/1205 in Tönning.",
    tags: ["cable"],
    tagLabel: "Cable Laying",
    image: imgBv26,
    summary: [
      "Route: 1204/1205",
      "Scope of work: Cable laying",
      "Period: Oct 2023",
    ],
    logistics: ["Route-specific construction logistics"],
  },
  bv111: {
    title: "BV 111 Gundersheim 2024",
    subtitle: "Cable duct size II iF installation with precast concrete elements according to Ril 836.4101.",
    tags: ["infrastructure"],
    tagLabel: "Cable duct size II iF",
    image: imgBv111,
    summary: [
      "Installation of a size II i.F. cable duct with internal precast-concrete covers",
      "Compliant to Ril 836.4101 (Figure 1) and BZA drawings S 4201 05,2",
      "Concrete quality used: C 30/37 according to EN 206-1.",
      "Cable duct specifications: clear length 1000 mm, clear width 240 mm, clear height 155 mm.",
      "Cable trough: 1 piece/m with front-face socket rabbet connection.",
      "Covers: 2 pieces/m, dimensioned and tested for a 10 kN load, construction length 500 mm.",
      "Installation executed in side, intermediate, and shunting paths without protective layer.",
    ],
    logistics: [
      "Earthworks: excavation along the specified route alignment to prepare the side path.",
      "Material transport and storage: excess material was properly removed and stored.",
    ],
  },
  bv164: {
    title: "BV 164 ESTW Mönchhof 2023",
    subtitle: "Cable civil engineering, cable pulling, and cable laying on route 3539.",
    tags: ["cable"],
    tagLabel: "Cable Civil Works",
    image: imgBv164,
    summary: [
      "Route: 3539",
      "Scope: Cable civil works and laying",
      "Period: Oct 23",
    ],
    logistics: ["Construction and pulling equipment per route"],
  },
  bv159: {
    title: "BV 159 Cologne Hürth 2023",
    subtitle: "Cable Laying, cable pulling, and cable laying for LST/TK and OSE power cables.",
    tags: ["cable"],
    tagLabel: "Cable Laying / Cable Pulling",
    image: imgBv159,
    summary: [
      "Routes: 2630 / 2638 / 3510",
      "Scope: LST/TK and OSE cable works",
      "Period: Oct 23",
    ],
    logistics: ["Integrated multi-route execution"],
  },
  bv154: {
    title: "BV 154 Aschaffenburg 2023",
    subtitle: "Cable Laying works on route 5201 in Aschaffenburg.",
    tags: ["cable"],
    tagLabel: "Cable Laying",
    image: imgBv154,
    summary: [
      "Route: 5201",
      "Scope: Cable Laying",
      "Period: Oct 23",
    ],
    logistics: ["Route-specific civil works planning"],
  },
  bv149: {
    title: "BV 149 Kempten 2023",
    subtitle: "Cable civil engineering and cable pulling on route 5400.",
    tags: ["cable"],
    tagLabel: "Civil Works & Pulling",
    image: imgBv149,
    summary: [
      "Route: 5400",
      "Scope: Civil works and cable pulling",
      "Period: Sep 23",
    ],
    logistics: ["Field equipment and pulling logistics per route"],
  },
  bv146: {
    title: "BV 146 Nettersheim 2023",
    subtitle: "Cable Laying works on route 2631 in Nettersheim.",
    tags: ["cable"],
    tagLabel: "Cable Laying",
    image: imgBv146,
    summary: [
      "Route: 2631",
      "Scope: Cable Laying",
      "Period: Sep 23",
    ],
    logistics: ["Route preparation and trenching execution"],
  },
  bv144: {
    title: "BV 144 Fishing 2023",
    subtitle: "Cable Laying package on route 5402 at location Fishing.",
    tags: ["cable"],
    tagLabel: "Cable Laying",
    image: imgBv144,
    summary: [
      "Route: 5402",
      "Scope: Cable Laying",
      "Period: Oct 23",
    ],
    logistics: ["Construction schedule and route coordination"],
  },
  bv155: {
    title: "BV 155 Koblenz 2023",
    subtitle: "Cable Laying package on route 2630 in Koblenz.",
    tags: ["cable"],
    tagLabel: "Cable Laying",
    image: imgBv155,
    summary: [
      "Route: 2630",
      "Scope: Cable Laying",
      "Period: Oct 23",
    ],
    logistics: ["Route-specific trenching logistics"],
  },
};

export const projectsDataAr = {
  bv128: {
    title: "BV 128 - التجديد العام لخط ريدبان",
    subtitle: "توجيه وتجديد شامل لكابلات LST على طول ممر ريدبان.",
    tags: ["lst"],
    tagLabel: "توجيه كابل LST",
    image: imgBv128,
    summary: [
      "84 كم كابل رئيسي - تم المد في الموعد المحدد",
      "15 كم كابل فرعي - تنفيذ دقيق",
      "20 كم قنوات كابلات - فتح وتنظيف وإغلاق احترافي",
      "43 كم إعادة توجيه الكابلات - مكتملة في الموعد المحدد",
      "4 كم قناة كابلات مؤقتة - إنشاء جديد",
      "7 كم سحب كابل في النفق - تقنية سحب خاصة",
      "1 كم تركيب كابل على قدم السكة في قضيب E60 بمشابك قضيب",
      "170 نقل أسطوانة",
      "أعمال مدنية إضافية للكابلات",
      "تركيب خزانة كابلات مع خطة PT2",
      "تخطيط مشترك وتركيب مدخل كابل",
    ],
    logistics: [
      "2 مقطورة أسطوانة بسعة 4.5 طن لكل منهما",
      "1 شاحنة بسعة 120 طن",
      "2 رافعة شوكية لفرز الأسطوانات",
      "1 حفارة ذات اتجاهين",
      "2 بكرة حبل مساعدة HSW-B 750",
      "قضبان فايبرغلاس RUNPOTEC: 400 م، 200 م، 120 م",
      "300 بكرة كابل",
      "مركبة خدمة سكة حديدية SKL 53 مع مقطورة سكة حديدية",
      "مشابك سحب كابل مع حلقة: 20 مم، 40 مم، 60 مم، 80 مم، 120 مم، 160 مم",
    ],
  },
  bvdornheim: {
    title: "BV دورنهايم - دورنبرج-نورد",
    subtitle: "12.5 كم من توجيه كابلات LST مع تنظيف القنوات والختم والتركيب تحت الأرض.",
    tags: ["lst"],
    tagLabel: "توجيه كابل LST",
    image: imgBvDor,
    summary: [
      "12.5 كم كابل رئيسي - تم المد في الموعد المحدد",
      "12 كم قنوات كابلات - فتح وتنظيف وإغلاق احترافي",
      "27 نقل أسطوانة",
      "أعمال مدنية إضافية للكابلات",
      "تطبيق 2,500 شريط تعريف كابل",
      "تركيب مدخل كابل",
    ],
    logistics: [
      "1 مقطورة أسطوانة بسعة 4.5 طن",
      "1 حفارة ذات اتجاهين",
      "2 بكرة حبل مساعدة HSW-B 750",
      "300 بكرة كابل",
      "مركبة خدمة سكة حديدية SKL 53 مع مقطورة سكة حديدية",
    ],
  },
  bv99: {
    title: "BV 99 ESTW ليبلوس 2024",
    subtitle: "15.8 كم من تركيب كابلات LST مع ألياف بصرية وأعمال نفق ولوجستيات دقيقة.",
    tags: ["lst"],
    tagLabel: "تركيب كابل LST",
    image: imgBv99,
    summary: [
      "15.8 كم كابل LST - تركيب فعال وفي الموعد المحدد",
      "25 كم كابل ألياف بصرية - تنفيذ دقيق للتركيب",
      "11 كم كابل فرعي - تنفيذ دقيق",
      "29.5 كم قنوات كابلات - أعمال نباتية وفتح وتنظيف وإغلاق احترافي",
      "1 كم سحب كابل في النفق - تقنية سحب خاصة",
      "18 خزانة ألياف إضافية - تقنية تغذية خاصة",
      "27 نقل أسطوانة وأعمال مدنية إضافية للكابلات",
      "تطبيق 10,000 شريط تعريف كابل",
    ],
    logistics: [
      "1 مقطورة أسطوانة بسعة 4.5 طن",
      "1 حفارة ذات اتجاهين",
      "2 بكرة حبل مساعدة HSW-B 750",
      "300 بكرة كابل",
      "مشابك سحب كابل مع حلقة: 20 مم، 40 مم، 60 مم، 80 مم، 120 مم، 160 مم",
    ],
  },
  bv74: {
    title: "BV 74 ESTW S8 شمال و ESTW S1 شمال 2024",
    subtitle: "ترقية الممر بالمسارات والتصريف والمنصات وتوجيه كابلات LST/50 هرتز الموثوق.",
    tags: ["lst"],
    tagLabel: "كابل LST و50 هرتز",
    image: imgBv74,
    summary: [
      "81 كم كابل رئيسي - تم المد في الموعد المحدد",
      "11 كم كابل فرعي - تنفيذ دقيق",
      "8.5 كم قنوات كابلات - فتح وتنظيف وإغلاق احترافي",
      "7 كم سحب كابل في النفق - تقنية سحب خاصة",
      "1 كم تركيب كابل على قدم السكة في قضيب E60 بمشابك قضيب",
      "101 نقل أسطوانة",
      "أعمال مدنية إضافية للكابلات وتخطيط مشترك",
    ],
    logistics: [
      "2 مقطورة أسطوانة بسعة 4.5 طن لكل منهما",
      "1 حفارة ذات اتجاهين",
      "1 بكرة حبل مساعدة HSW-B 750",
      "300 بكرة كابل",
      "مركبة خدمة سكة حديدية SKL 53 مع مقطورة سكة حديدية",
      "مشابك سحب كابل مع حلقة: 20 مم، 40 مم، 60 مم، 80 مم، 120 مم، 160 مم",
    ],
  },
  bv26: {
    title: "BV 26 تونينج 2023",
    subtitle: "حزمة مد الكابلات للمسار 1204/1205 في تونينج.",
    tags: ["cable"],
    tagLabel: "مد الكابلات",
    image: imgBv26,
    summary: [
      "المسار: 1204/1205",
      "نطاق العمل: مد الكابلات",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["لوجستيات بناء خاصة بالمسار"],
  },
  bv111: {
    title: "BV 111 غوندرسهايم 2024",
    subtitle: "تركيب قناة كابل بحجم II iF مع عناصر خرسانة مسبقة الصنع وفقاً للمعيار Ril 836.4101.",
    tags: ["infrastructure"],
    tagLabel: "قناة كابل حجم II iF",
    image: imgBv111,
    summary: [
      "تركيب قناة كابل بحجم II i.F. مع أغطية خرسانة مسبقة الصنع داخلية",
      "متوافقة مع Ril 836.4101 (الشكل 1) ورسومات BZA S 4201 05,2",
      "جودة الخرسانة المستخدمة: C 30/37 وفقاً للمعيار EN 206-1.",
      "مواصفات قناة الكابل: الطول الصافي 1000 مم، العرض الصافي 240 مم، الارتفاع الصافي 155 مم.",
      "قناة الكابل: قطعة واحدة/م مع وصلة ربط على الوجه الأمامي.",
      "الأغطية: قطعتان/م، مصممة ومختبرة لحمل 10 كيلونيوتن، طول البناء 500 مم.",
      "التركيب في المسارات الجانبية والوسطى وسكة الترتيب دون طبقة حماية.",
    ],
    logistics: [
      "أعمال ترابية: حفر على طول محاذاة المسار المحدد لتحضير المسار الجانبي.",
      "نقل المواد وتخزينها: تمت إزالة المواد الزائدة وتخزينها بشكل مناسب.",
    ],
  },
  bv164: {
    title: "BV 164 ESTW مونشهوف 2023",
    subtitle: "هندسة مدنية للكابلات وسحبها ومدها على المسار 3539.",
    tags: ["cable"],
    tagLabel: "أعمال مدنية للكابلات",
    image: imgBv164,
    summary: [
      "المسار: 3539",
      "النطاق: أعمال مدنية للكابلات ومدها",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["معدات البناء والسحب لكل مسار"],
  },
  bv159: {
    title: "BV 159 كولونيا هيرث 2023",
    subtitle: "مد الكابلات وسحبها لكابلات طاقة LST/TK وOSE.",
    tags: ["cable"],
    tagLabel: "مد الكابلات / سحب الكابلات",
    image: imgBv159,
    summary: [
      "المسارات: 2630 / 2638 / 3510",
      "النطاق: أعمال كابلات LST/TK وOSE",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["تنفيذ متكامل متعدد المسارات"],
  },
  bv154: {
    title: "BV 154 أشافنبورغ 2023",
    subtitle: "أعمال مد الكابلات على المسار 5201 في أشافنبورغ.",
    tags: ["cable"],
    tagLabel: "مد الكابلات",
    image: imgBv154,
    summary: [
      "المسار: 5201",
      "النطاق: مد الكابلات",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["تخطيط أعمال مدنية خاصة بالمسار"],
  },
  bv149: {
    title: "BV 149 كيمبتن 2023",
    subtitle: "هندسة مدنية للكابلات وسحبها على المسار 5400.",
    tags: ["cable"],
    tagLabel: "أعمال مدنية وسحب",
    image: imgBv149,
    summary: [
      "المسار: 5400",
      "النطاق: أعمال مدنية وسحب كابلات",
      "الفترة: سبتمبر 2023",
    ],
    logistics: ["معدات ميدانية ولوجستيات سحب لكل مسار"],
  },
  bv146: {
    title: "BV 146 نيترسهايم 2023",
    subtitle: "أعمال مد الكابلات على المسار 2631 في نيترسهايم.",
    tags: ["cable"],
    tagLabel: "مد الكابلات",
    image: imgBv146,
    summary: [
      "المسار: 2631",
      "النطاق: مد الكابلات",
      "الفترة: سبتمبر 2023",
    ],
    logistics: ["تحضير المسار وتنفيذ الحفر"],
  },
  bv144: {
    title: "BV 144 فيشينج 2023",
    subtitle: "حزمة مد الكابلات على المسار 5402 في موقع فيشينج.",
    tags: ["cable"],
    tagLabel: "مد الكابلات",
    image: imgBv144,
    summary: [
      "المسار: 5402",
      "النطاق: مد الكابلات",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["الجدول الزمني للبناء وتنسيق المسار"],
  },
  bv155: {
    title: "BV 155 كوبلنز 2023",
    subtitle: "حزمة مد الكابلات على المسار 2630 في كوبلنز.",
    tags: ["cable"],
    tagLabel: "مد الكابلات",
    image: imgBv155,
    summary: [
      "المسار: 2630",
      "النطاق: مد الكابلات",
      "الفترة: أكتوبر 2023",
    ],
    logistics: ["لوجستيات الحفر الخاصة بالمسار"],
  },
};

export default projectsDataEn;
